import { Link } from 'react-router';

import { useGetReservations } from '@/api';
import { AllNumbers } from '@/components/AllNumbers/AllNumbers.tsx';
import { HeartIcon } from '@/components/icons/my-reservations';
import { Button } from '@/components/shared/Button';
import { appRoutes } from '@/routes/app-routes.ts';

import cn from './styles.module.sass';

export const MyReservations = () => {
    const { data } = useGetReservations();

    return (
        <div className={cn.container}>
            <h2 className={cn.pageHeading}>Мои брони</h2>
            <div className={cn.description}>
                <p>Забронируй до 10 номеров на 24 часа, чтобы успеть выбрать лучший из них!</p>
                <p>Чтобы купить номер или отменить бронь, выбери тариф внутри номера</p>
            </div>
            {data === undefined || data.length > 0 ? (
                <AllNumbers hasHead={false} hasLoadMore={false} />
            ) : (
                <div className={cn.noReservations}>
                    <div className={cn.iconContainer}>
                        <span>{HeartIcon}</span>
                    </div>
                    <div className={cn.noReservationsText}>Еще нет броней</div>
                    <Link className={cn.homeLink} to={appRoutes.mainPage}>
                        <Button>Выбрать номера</Button>
                    </Link>
                </div>
            )}
        </div>
    );
};
